import { React, Component } from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { inject, observer } from 'mobx-react';
import { css } from '@emotion/core';
import Spinner from '../common/spinner';
import CommonButton from '../common/Button';
import {
  CustomModal,
  CloseButtonContainer,
  PopUpBody,
  MessageBody,
  LogoWrapper,
  LogoWrapperInner,
} from './styled';
import IconSvg from '../common/IconSvg';
import Logo from '../Logo';
// import { Multiregion-Germany } from '../../../assets/images';

@inject('settingsStore')
@observer
class NewsPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enabled: true,
      hasPlan: true,
      loading: false,
    };
  }

  closePopUp = () => {
    this.setState({ enabled: false });
  };

  // handleClick = e => {
  //   const {
  //     settingsStore: {
  //       subscription: { activePlan, toggleAddOn, updateAddOns, removeAddOn },
  //     },
  //   } = this.props;

  //   this.setState({ loading: true });

  //   const id = activePlan?.allowedAddOnPlans[1]?.id;
  //   const typeId = activePlan?.allowedAddOnPlans[1]?.typeId;
  //   const toggledOffId = activePlan?.allowedAddOnPlans[0]?.id;

  //   if (id) {
  //     toggleAddOn(e, id);
  //     removeAddOn(toggledOffId);

  //     const addOnsChanges = [
  //       {
  //         newAddOnPlanId: id,
  //         typeId,
  //       },
  //     ];

  //     updateAddOns(addOnsChanges).then(() => {
  //       this.closePopUp();
  //       this.setState({ loading: false });
  //     });
  //   }
  // };

  showUpdateMessage=()=>{
    // eslint-disable-next-line no-useless-escape
    const message=`Exciting news! We are thrilled to announce that Triplemars has expanded its services to include more European Regions!
    Now you can list items from Amazon to your eBay stores on European regions.
    How to Get Started? All you need to do is to select the region flag in the flags dropdown at the top right side of the page and the whole system will switch to requested region.
    Please pay attention! you will need to load your balance on Euro in order to fulfil orders in Europe.
    Have questions or need assistance? Our support team is here on the chat to help you every step of the way.`;
    return message
  }
  render() {

    const {
      settingsStore: {
        subscription: { activePlan },
      },
    } = this.props;

    if (this.state.hasPlan && activePlan?.allowedAddOnPlans[1]?.isSelected === false) {
      this.setState({ hasPlan: false });
    }

    return (
      <div>
        {this.state.enabled && !this.state.hasPlan ? (
          <CustomModal
            visible
            closable={false}
            width="720px"
            footer={null}
            onCancel={this.props.confirmationRequired ? null : this.closePopUp}
          >
            <CloseButtonContainer>
              <IconSvg type="x" size={10} onClick={this.closePopUp} />
            </CloseButtonContainer>
            <PopUpBody>
              <LogoWrapper>
                <LogoWrapperInner>
                  <Logo />
                </LogoWrapperInner>
              </LogoWrapper>
              <MessageBody css={css`text-align:start;padding:15px;`}>
                <div css={css`display:flex;justify-content:center;font-size:20px;font-weight:bold;`}>
                  <FormattedMessage id="newsPopUp.title" />
                </div>
                <FormattedMessage id={this.showUpdateMessage()} />
                <div>
                  <img src="../../../assets/images/Multiregion-Germany.jpg" width={600} height={200} />
                </div>
              </MessageBody>
              <CommonButton
                css={css`
                  width: 300px;
                  height: 35px;
                  font-size: 14px;
                  align-self: center;
                  display: none;
                `}
                clickHandler={this.handleClick}
              >
                <FormattedMessage id="promotionPopUp.buttonText" />
              </CommonButton>
            </PopUpBody>
          </CustomModal>
        ) : null}
        {this.state.loading && <Spinner />}
      </div>
    );
  }
}

NewsPopUp.propTypes = {
  confirmationRequired: PropTypes.bool,
};

export default NewsPopUp;
